import { format } from "date-fns";
import { useUpdateEvidence } from "../../api/evidence";
import { errorToast, successToast } from "../../toast";
import DialogBox from "../DialogBox";
import { EditEvidenceFormValues } from "../EditEvidenceForm/EditEvidenceFormValues";
import EditEvidenceForm from "../EditEvidenceForm";

export type EditEvidenceDialogProps = {
    isOpen: boolean;
    onClose: (evidenceSubmitted: boolean) => void;
    currentEvidenceId?: number;
    validFromDate?: Date;
    validToDate?: Date;
};

const EditEvidenceDialog = ({
    isOpen,
    onClose,
    currentEvidenceId,
    validFromDate,
    validToDate,
}: EditEvidenceDialogProps) => {
    const [updateEvidence, isUpdatingEvidence] = useUpdateEvidence(
        currentEvidenceId ?? -1
    );

    const handleEditEvidenceFormSubmission = async (
        value: EditEvidenceFormValues
    ) => {
        if (value.validFromDate !== null && value.validToDate !== null) {
            const response = await updateEvidence({
                validFromDate: format(value.validFromDate, "yyyy-MM-dd"),
                validToDate: format(value.validToDate, "yyyy-MM-dd"),
            });

            if (!response.success) {
                errorToast(
                    "There was a problem updating evidence - please try again"
                );
                return;
            }

            successToast("Evidence updated");
            onClose(true);
        }
    };

    return (
        <DialogBox
            title="Update evidence"
            isOpen={isOpen}
            onClose={() => onClose(false)}
        >
            {currentEvidenceId && (
                <EditEvidenceForm
                    initialValues={{
                        validFromDate: validFromDate ?? null,
                        validToDate: validToDate ?? null,
                    }}
                    isLoading={isUpdatingEvidence}
                    onSubmit={handleEditEvidenceFormSubmission}
                    onCancel={() => onClose(false)}
                />
            )}
        </DialogBox>
    );
};

export default EditEvidenceDialog;
